import { Chip as MuiChip, chipClasses } from '@mui/material';
import { styled } from '../muiReexports';
export const ChipWithShapeStyled = styled(MuiChip, { shouldForwardProp: (prop) => prop !== 'shape' })(({ shape }) => ({
    ...(shape === 'rect' && {
        [`&.${chipClasses.sizeSmall}`]: {
            borderRadius: `var(--gp-radius-md)`,
        },
        [`&.${chipClasses.sizeMedium}`]: {
            borderRadius: `var(--gp-radius-md)`,
        },
    }),
}));
